import { render, staticRenderFns } from "./ShockAbsorber.vue?vue&type=template&id=6ee47e3d"
import script from "./ShockAbsorber.vue?vue&type=script&lang=js"
export * from "./ShockAbsorber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports